import actions from './actions';

const {
    STATISTIQUE,
    STATISTIQUE_ADS,
    ALL_MISSIONS,
    ALL_CONTACT,
    DETAIL_AD,
    DETAIL_ANNONCE,
    REQUEST_STATUS,
} = actions;

const initialState = {
    stat: null,
    statAds: null,
    allMissions: null,
    allContact: null,
    detailAd: null,
    pinned: null,
    detailAnnonce: null,
    requestStatus: {
        pending: false,
        success: false,
        error: false
    },
};

const missionReducer = (state = initialState, action) => {
    const { type, data } = action;
    switch (type) {
        case DETAIL_ANNONCE:
            return { ...state, detailAnnonce: data };
        case STATISTIQUE:
            return { ...state, stat: data };
        case STATISTIQUE_ADS:
            return { ...state, statAds: data };
        case ALL_MISSIONS:
            return { ...state, allMissions: data };
        case ALL_CONTACT:
            return { ...state, allContact: data };
        case DETAIL_AD:
            return { ...state, detailAd: data };
        case REQUEST_STATUS:
            return {
                ...state,
                requestStatus: {
                    ...state.requestStatus,
                    pending: data.key === 'pending' ? data.value : false,
                    success: data.key === 'success' ? data.value : false,
                    error: data.key === 'error' ? data.value : false,
                },
            };
        default:
            return state;
    }
};

export default missionReducer;
